"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgOpenBookOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M18.995 5.507C12.5 5.677 12.5 7.494 12.5 7.494v10s2.166-1.733 6.5-1.973c.55-.03 1-.475 1-1.027v-8a.985.985 0 00-1.005-.987zm-13.99.001A.981.981 0 004 6.494v8c0 .552.45.997 1 1.027 4.333.24 6.5 1.973 6.5 1.973V7.617a.483.483 0 00-.049-.235c-.215-.396-1.314-1.72-6.447-1.874zM2 8.494a1 1 0 011-1v6.639c0 1.236 1.117 2.192 2.352 2.201 1.91.014 4.471.395 5.648 2.16H3a1 1 0 01-1-1v-9zm19-1a1 1 0 011 1v9a1 1 0 01-1 1h-8c1.177-1.765 3.738-2.146 5.648-2.16C19.883 16.325 21 15.37 21 14.133v-6.64zM6 7.5S9.5 8 9.5 9v5.5s-2-1-3.5-1v-6zm12 0S14.5 8 14.5 9v5.5s2-1 3.5-1v-6z' }))); };
exports.default = SvgOpenBookOutline;
//# sourceMappingURL=OpenBookOutline.js.map